// Update your baseUrl here
const baseUrl = process.env.REACT_APP_API_URL;
// const baseUrl = 'https://vergeca.in/G8g2GpupCrxpsED-vergeca-v2-bSfejdRNEKd3Blq/admin_api/index.php/api/';

export default baseUrl;